import { SpecialCharacterSlug } from './formValidation'

export function removeSpecialCharacterFromText(text: string, replaceValue = ''): string {
  return text.replace(SpecialCharacterSlug, replaceValue)
}

export function normalizeField(field: string): string {
  return field.replace(/([a-z])([A-Z])/g, '$1 $2')
}

export function truncateString(str: string, characters: number): string {
  if (str.length <= characters) {
    return str
  }
  return str.slice(0, characters) + '...'
}

export function truncateToTwoDecimalPlaces(amount: number | string): number {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount
  return Math.floor(num * 100) / 100
}

export const formatBooleanValue = (value?: string): boolean => {
  return value?.toLowerCase() === 'true'
}

export function isUUID(value: string): boolean {
  const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  return regex.test(value)
}

export function camelCaseToSeparatedWords(input: string): string {
  const regex = /([a-z])([A-Z])/g
  const result = input.replace(regex, '$1 $2').replace(/^./, (str) => str.toUpperCase())

  return result
}
